'use es6';

import { hasInlineImagesStripped, getAttachmentStrippedCount } from './commonMessageFormatGetters';
export const getIsEmailAttachmentDisabled = message => hasInlineImagesStripped(message) || getAttachmentStrippedCount(message) > 0;